import PostModel, { PostingModel } from "app/models/PostModel";
import { usePostingFormBase } from "app/utils/hooks/usePostingFormBase";
import { shallowEqual, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "typedefs";

interface Props {
  onPost?: (post: PostModel) => void;
}

export const useTemplatePostingForm = ({ onPost }: Props) => {
  const { selectedTemplate } = useSelector(
    (state: RootState) => state.spaceTemplate,
    shallowEqual,
  );

  const { id: templateId } = useParams<{ id: string }>();

  const { user, canSchedulePosts, canUploadMedia, postActions } =
    usePostingFormBase();

  if (!selectedTemplate) {
    return null;
  }

  const onSubmit = (data: PostingModel) => {
    if (templateId) {
      postActions
        .createPost({ ...data, space_template_id: templateId })
        .then((res) => {
          if (onPost) {
            onPost({ ...res, userAvatar: user.avatar });
          }
        });
    }
  };

  return {
    canUploadMedia,
    user,
    onSubmit,
    canSchedulePosts,
  };
};
